// extracted by mini-css-extract-plugin
export default {"title":"metode-pembayaran-properti_title__5BdJJ"};